export const selectionType = {
  noSelection: 'No selection',
  selectedbySupplier: 'Selected by Supplier',
  selectedbyItem: 'Selected by Item',
  allocated: 'Allocated',
}

export const allowcateType = {
  qty: 'QTY',
  percent: 'Percent',
}
